module.exports = __webpack_public_path__ + "static/img/wanted6.992d019.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/wanted6.png
// module id = FBPe
// module chunks = 1 3